import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { HeadquarterWiseSalesType } from "../../../domain/models/headquarter-wise-sales/headquarter-wise-sales-type";
import { FetchHeadquarterWiseSales } from "../../../domain/useages/headquarter-wise-sales/fetchHeadquarterWiseSales";
import { RemoteFetchHeadquarterWiseSales } from "../../../data/usecases/headquarter-wise-sales/remote-fetch-headquarter-wise-sales";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface HeadquarterWiseSalesSliceInterface {
  fetchHeadquarterWiseSales: Function;
  HeadquarterWiseSalesData: HeadquarterWiseSalesType;
  HeadquarterWiseSalesState: FetchState;
}

const initialStates = {
  HeadquarterWiseSalesData: {} as HeadquarterWiseSalesType,
  HeadquarterWiseSalesState: FetchState.DEFAULT,
};
const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchHeadquarterWiseSalesSlice: StateCreator<
  HeadquarterWiseSalesSliceInterface
> = (set, get) => ({
  ...initialStates,
  fetchHeadquarterWiseSales: async (
    month: number,
    year: number,
    filters: FetchHeadquarterWiseSales.Params
  ) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    set({ HeadquarterWiseSalesState: FetchState.LOADING });

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchHeadquarterWiseSales: FetchHeadquarterWiseSales =
      new RemoteFetchHeadquarterWiseSales(
        `${BASE_URL}${Endpoints.FETCH_HEADQUARTER_WISE_SALES}`,
        axiosHttpClient
      );
    let result = await remoteFetchHeadquarterWiseSales.fetch(
      month,
      year,
      filters
    );

    if (result.customers.length !== 0) {
      set({
        HeadquarterWiseSalesData: result,
        HeadquarterWiseSalesState: FetchState.SUCCESS,
      });
    } else {
      set({ HeadquarterWiseSalesState: FetchState.ERROR });
    }
  },
});
